import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../../Components/Header/Header";
import SwitchBox from "../../../../Components/FormControl/SwitchBox/SwitchBox";
import { AppContext } from "../../../../Context/AppContext";
import { MODULES } from "../../../../Helpers/Constants";
import { getAccessByModuleName } from "../../../../Routes/Routes";
import styles from "./index.module.scss";
import { formatUsPhone } from "../../../../Hooks/commanUtility";
import PetalRewards from "../../../customers/details/petalRewards";
import LoadingScreen from "../../../../Components/Loading/LoadingScreen";
import PaymentCardApi from "../../../../Services/PaymentCard/PaymentCard";
import PaymentHistoryCard from "../../../../Components/PaymentHistoryCard/PaymentHistoryCard";
import CustomerOrderHistory from "../CusomerOrderHistory/CustomerOrderHistory";
import { getCustomerDetailsWithOrderHistory } from "api/customer";
import Text from "Components/FormControl/Text/Text";

const SystemAccountDetails = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const [userDetails, setUserDetails] = useState(null);
  const [paymentCardDetails, setPaymentCardDetails] = useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const [access, setAccess] = useState({});

  const [submitClick, setSubmitClick] = useState(false);

  const paymentService = new PaymentCardApi();

  useEffect(() => {
    const fetchApiData = async () => {
    let accountAccess = getAccessByModuleName(
      modules,
      MODULES.SYSTEM_ACCOUNT_LOOKUP
    );
    if (accountAccess && accountAccess.permissions.write_access) {
      await handleGetUserData();
    }
  }
    fetchApiData();
  }, [params.id, submitClick]);

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);
  useEffect(() => {
    handleGetPaymentCard();
  }, []);
  const handleGetPaymentCard = async () => {
    const getPaymentBody = {
      id: params.id,
      isAllStoresCards: true,
    };
    await paymentService
      .getPaymentCardlist(getPaymentBody)
      .then((data) => {
        if (data && data.status === 200) {
          setPaymentCardDetails(data.data.data.rows);
        } else {
          showToastMessage(undefined, data.data.data.message, "error", false);
        }
      })
      .catch((error) => {
        showToastMessage(undefined, error.data.message, "error", false);
      });
  };

  const handleGetUserData = async () => {
    const { id } = params;
    if (!id) return;

    let selectedStore = localStorage.getItem("selectedStore");
    const postData = {
      id,
      selectedStore: selectedStore,
    };
    await getCustomerDetailsWithOrderHistory(postData)
      .then((data) => {
        if (data && data.status === 200) {
          setUserDetails(data.data.data);
        } else {
          showToastMessage(undefined, data.data.message, "error", false);
        }
        setSubmitClick(false);
      })
      .catch((err) => {
        showToastMessage(undefined, err.data.message, "error", false);
      });
  };

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.SYSTEM_ACCOUNT_LOOKUP);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.write_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }

  const handleSeeAllClick = async (event, link) => {
    event.preventDefault();
    navigate(link);
  };

  if (!userDetails) return <LoadingScreen />;

  return (
    <React.Fragment>
      <Header
        title={`System Account Lookup ${
          userDetails.customer
            ? "- " +
              userDetails.customer.first_name +
              " " +
              userDetails.customer.last_name
            : ""
        }`}
      />

      {access.read_access && (
        <div id="MainContent" className="main-content">
          <div className="container-fluid">
            <h3 className="bold mt-5 mb-3 d-flex align-items-center">
              <span>Personal Information</span>
            </h3>
            <div className="row">
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  First Name
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer &&
                  userDetails.customer.first_name !== null
                    ? userDetails.customer.first_name
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Last Name
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer &&
                  userDetails.customer.last_name !== null
                    ? userDetails.customer.last_name
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-6 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Email
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer.email !== null
                    ? userDetails.customer.email
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Phone 1
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer?.phone
                    ? userDetails.customer?.country_code +
                      " " +
                      formatUsPhone(userDetails.customer.phone)
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Phone 2
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer && userDetails.customer?.alt_phone
                    ? userDetails.customer?.alt_country_code +
                      " " +
                      formatUsPhone(userDetails.customer.alt_phone)
                    : "-"}
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  House Account
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  <SwitchBox
                    value={
                      userDetails.customer
                        ? userDetails.customer.is_house_account
                        : 0
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className={`col-12 col-lg-3 mb-4`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  Business Account
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  <SwitchBox
                    value={
                      userDetails.customer
                        ? userDetails.customer.is_business_account
                        : 0
                    }
                    disabled={true}
                  />
                </div>
              </div>
              <div className={`col-12 col-lg-9 mb-8`}>
                <div className={`${styles.PersonalInformationLabel}`}>
                  What's unique about this customer?
                </div>
                <div className={`${styles.PersonalInformationDetail}`}>
                  {userDetails.customer
                    ? userDetails.customer.unique_about_customer
                    : "-"}
                </div>
              </div>
            </div>
            <h3 className="bold mt-5 mb-4">Summary</h3>
            <div className={`${styles.OrderSummaryCard}`}>
              <div className="row">
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.total_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Total Orders
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    $
                    {userDetails.avg_order_value
                      ? userDetails.avg_order_value.toFixed(2)
                      : 0}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    AVG Order Value
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.refunded_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Refunded Orders
                  </div>
                </div>
                <div
                  className={`${styles.OrderSummaryItem} col-12 col-lg-3 col-sm-12 col-xs-12`}
                >
                  <div className={`${styles.OrderSummaryDetail}`}>
                    {userDetails.replaced_orders}
                  </div>
                  <div className={`${styles.OrderSummaryLabel}`}>
                    Replaced Orders
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
            <h3 className="bold mt-5 mb-2">
              Order History
              <span
                className={`cursor-pointer ${styles.SeeAllLink}`}
                onClick={(e) =>
                  handleSeeAllClick(
                    e,
                    `/reports/system-customer-order-history/${
                      userDetails.customer.id
                    }/${
                      userDetails.customer
                        ? userDetails.customer.first_name +
                          " " +
                          userDetails.customer.last_name
                        : ""
                    }`
                  )
                }
              >
                See All
              </span>
            </h3>
            <div className="row">
              {userDetails.customer_orders &&
              userDetails.customer_orders.length > 0
                ? userDetails.customer_orders.map((data, index) => {
                    let card_data = {
                      orderId: data.order_number,
                      id: data.id,
                      price: data.total,
                      orderStatus: data.order_status,
                      // date: data.createdAt,
                      date: data.delivery_date_time,
                      refundAmount:
                        data.refund && data.refund !== null ? data.refund : 0,
                    };

                    let recipients_data = [];
                    data.order_recipients.map((recipient) => {
                      recipients_data.push(recipient.first_name);
                      return recipients_data;
                    });
                    card_data.name = recipients_data.join(", ");

                    return (
                      <div
                        className={`col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-3 pb-3 ${styles.OrderHistoryWrapper}`}
                      >
                        <CustomerOrderHistory key={index} data={card_data} />
                      </div>
                    );
                  })
                : ""}
            </div>
            <h3 className="bold mt-5 mb-2">Payment Methods</h3>
            <div className="row">
              {paymentCardDetails && paymentCardDetails.length > 0 ? (
                paymentCardDetails.map((data, index) => {
                  //This is done for hide card edit icon for all kind of payment gateway even paybali or braintree
                  //For further improvement we have latest changes accordingly as per the current requirement
                  const tempData = {
                    ...data,
                    payment_method: "payabli",
                  };
                  return (
                    <div
                      className={`col-12 col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-3 pb-3 ${styles.OrderHistoryWrapper}`}
                    >
                      <PaymentHistoryCard
                        key={index}
                        data={tempData}
                        EditClick={() => {
                          return;
                        }}
                      />
                    </div>
                  );
                })
              ) : (
                <p
                  className="col-12 pt-4"
                  style={{
                    fontSize: "18px",
                    lineHeight: "24px",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  No Payment Method Found
                </p>
              )}
            </div>
            <h3 className="bold mt-5 mb-2">Petal Rewards</h3>
            {userDetails && (
              <div className="row">
                <div className="col-md-2 col-xs-12">
                  <Text
                    type="text"
                    label="Customer"
                    value={userDetails?.customer?.first_name}
                    disabled={true}
                  />
                </div>
                <div className="col-md-2 col-xs-12">
                  <Text
                    type="text"
                    label="Total Points"
                    value={
                      userDetails?.customer.petal_rewards[0]?.total_points &&
                      userDetails?.customer.petal_rewards[0]?.total_points > 0
                        ? userDetails?.customer.petal_rewards[0]?.total_points
                        : "0"
                    }
                    disabled={true}
                  />
                </div>
              </div>
            )}
            <PetalRewards
              userDetails={userDetails}
              isAllStoresPetalReward={true}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SystemAccountDetails;
